import { FCX } from "@datassential/platform-ui-lib";
import { IconMacLogo } from "@icons";
import './MacsHeader.scss';
import Widget from "@components/Widget/Widget";
import { AiOutlineInfoCircle } from "react-icons/ai";

const MacsHeader: FCX = () => {
    return (
        <Widget className="MacsHeader" testId="blockMacsHeader">
            <div className="MacsHeader__content">
                <div className="MacsHeader__logo">
                    <IconMacLogo className="MacsHeader__logo-icon"/>
                </div>
                <div className="MacsHeader__description">
                    The MAC, Menu Adoption Cycle, tracks foods, beverages, and
                    ingredients along their trend curve across 4-stages:
                    <br/>
                    Inception, Adoption, Proliferation, and Ubiquity.
                    <span className="MacsHeader__description-icon-wrapper">
                        <a
                            href={`https://ds-projects-shared.s3.us-west-2.amazonaws.com/snap/MAC_DIAGRAM.pdf`}
                            target="_blank"
                            title="Download information"
                            rel="noreferrer"
                            className="MacsHeader__icon"
                            data-testid="buttonMacsDownloadInfo"
                        >
                            <AiOutlineInfoCircle/>
                        </a>
                    </span>
                </div>
            </div>
        </Widget>
    );
};

export default MacsHeader;
